import { addHours, isBefore, parseISO } from 'date-fns';

export const REOPEN_WINDOW_HOURS = 14 * 24;

/**
 * Whether a member activated recently enough to be offered the welcome modal
 * again. Takes `unknown` because the API's `DateTime` scalar is generated as
 * `any`; anything that is not a parseable date counts as outside the window.
 */
export const isWithinReopenWindow = (
  activationDate: unknown,
  now: Date,
): boolean => {
  if (typeof activationDate !== 'string') {
    return false;
  }

  const activatedAt = parseISO(activationDate);

  if (Number.isNaN(activatedAt.getTime())) {
    return false;
  }

  return isBefore(now, addHours(activatedAt, REOPEN_WINDOW_HOURS));
};
